function pad0AtStart(n) {
    if (n < 10) {
      return "0" + n;
    }
    return n;
}
  
export function getTimestampFromDuration(duration) {
  duration = Math.floor(duration);
  const hour = Math.floor(duration / 60);
  const minute = Math.floor(duration % 60);
  
  return pad0AtStart(hour) + ":" + pad0AtStart(minute);
}